interface FlagIconProps {
  code: string;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  className?: string;
}

/**
 * Displays a country flag using the flag-icons CSS library.
 * Handles US states (US-XX) and Canadian provinces (CA-XX) by showing
 * the parent country flag.
 */
export function FlagIcon({ code, size = 'md', className = '' }: FlagIconProps) {
  // Convert code to lowercase for flag-icons CSS
  let flagCode = code.toLowerCase();

  // For US states (e.g., US-NV), show US flag
  if (code.startsWith('US-')) {
    flagCode = 'us';
  }
  // For Canadian provinces (e.g., CA-ON), show Canada flag
  if (code.startsWith('CA-')) {
    flagCode = 'ca';
  }

  const sizeClasses = {
    xs: 'w-3 h-2',
    sm: 'w-4 h-3',
    md: 'w-6 h-4',
    lg: 'w-8 h-6',
  };

  return (
    <span
      className={`fi fi-${flagCode} ${sizeClasses[size]} inline-block rounded-sm shadow-sm bg-cover ${className}`}
      role="img"
      aria-label={`Flag of ${code}`}
    />
  );
}

export default FlagIcon;
